import { IFilesService } from './files.interface';

export class FilesService implements IFilesService {
  /**
   * Получить файл.
   *
   * @param url - Адрес ресурса.
   * @returns Объект с файлом (Promise<Blob>) и именем файла.
   */
  async getFile(url: string) {
    const blob = new Blob([url], { type: 'text/plain' });

    return {
      file: Promise.resolve(blob),
      filename: url,
    };
  }
}
